import Phaser from "phaser"
import { cGame } from "../cGame";
import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { getStr } from "../utils/simpleLocalisation";
import { ModuleCollection, Base } from "./modules";


export class cText extends Phaser.GameObjects.Text {

  public modules: ModuleCollection;
  private nw: any = {};
  private sData:ScreenItem
  private centerY: boolean = false;
  private curStyle: any 

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0,getStr(data.text) as any,sc.getStyle(data.textclass as string))

    this.curStyle = sc.getStyle(data.textclass as string)
    this.sData = data
    this.width = 1200;
    this.modules = Base.initModules(this,data)


    if (data.textstyle){
      this.curStyle = {...this.curStyle,...data.textstyle}
      //console.log("style",data.name, data.textstyle, this.curStyle)
    }
    cText.updateStyle(this, this.curStyle)
  }

  public set textdata( v:string ){
    this.text = getStr(v);
    //console.log("style", this.sData.name , this.curStyle)
    cText.updateStyle(this,this.curStyle);
  }

  public set styledata( st:any ){
    cText.updateStyle(this,st)
  }

  public calcTextHeight():number{
    var mm = this.getTextMetrics()
    var textLines = this.getWrappedText(this.text)
    var h = (mm.fontSize * textLines.length);

    return h
  }

  static updateStyle( tg:any, styles:any){
    //fix wordwrap  
    if (styles.wordWrap){      
      if (typeof styles.wordWrap !== 'object'){
        styles.wordWrap = {width: Number(styles.wordWrap) }
      }
    }

    if (styles.fixedWidth && styles.wordWrap){
      styles.wordWrap.width = styles.fixedWidth
    }
        
    if (cGame.debugmode){
      styles.backgroundColor = 'rgba(255,255,0,0.2)'
    }

    if (styles.textFrame){
      console.log('Ä>>>', styles.textFrame)
      var [sX,sY] = String(styles.textFrame).split('x') as any
      
      if (!styles.wordWrap) styles.wordWrap = {}
      styles.wordWrap.width = sX
      styles.fixedWidth = sX

      if (cGame.debugmode){
        //styles.fixedHeight = sY
      }

      var cc = 10
      var idd = setInterval(()=>{        
        var mm = tg.getTextMetrics()
        var textLines = tg.getWrappedText(tg.text)
        var h = (sY/2) - (mm.fontSize * textLines.length / 2) ;
        tg.setPadding(0,h,0,0)
        if (cc-- < 0) clearInterval(idd)
      },20);
    }

    tg.setStyle(styles)

    if (styles.lineSpacing){
      tg.setLineSpacing(Number(styles.lineSpacing))
    }

    // if (centerY){
    //   setTimeout(()=>{
    //     var h = (tHeight - tg.displayHeight) / 2;
    //     console.log('valign',h,tg.displayHeight, tHeight)
    //     tg.setPadding(0,h,0,0)
    //   },1)
    // }
  }


}